/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";

const ArrowView = styled.div`
  position: relative;
  left: 0;
  width: 50px;
  height: 52px;

  ${props =>
    props.intent === "CAST_UP" &&
    css`
    top: 88px;
  `}
`;

const PathView = React.memo(styled.path`
  ${props =>
    props.intent === "CAST_UP" &&
    css`
    fill: ${props => props.theme.upper};
  `}

  ${props =>
    props.intent === "CAST_DOWN" &&
    css`
    fill: rgb(230,76,60);
  `}
`);

function Svg({ children }: { children: React.Node }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50px"
      height="52px"
      fillRule="evenodd"
    >
      {children}
    </svg>
  );
}

type PathProps = {
  intent: "CAST_UP" | "CAST_DOWN",
  fillOpacity?: number,
  d: string
};

function Path(props: PathProps) {
  return <PathView {...props} />;
}

type ArrowProps = {
  intent: "CAST_UP" | "CAST_DOWN",
  style: Object
};

const Arrow = React.memo(function(props: ArrowProps) {
  return (
    <ArrowView {...props}>
      {props.intent === "CAST_UP"
        ? <Svg>
            <Path
              intent={props.intent}
              d="M47.936,4.610 L0.570,51.975 L0.573,48.642 L46.270,2.945 L46.268,2.943 L47.936,4.610 Z"
            />
            <Path
              intent={props.intent}
              fillOpacity={0.259}
              d="M44.989,51.024 L44.989,11.187 L46.179,9.997 L46.177,9.995 L46.989,9.183 L46.989,50.997 L44.989,51.024 ZM39.988,16.188 L41.989,14.187 L41.989,50.994 L39.988,50.995 L39.988,16.188 ZM34.988,21.188 L36.988,19.188 L36.988,50.987 L34.988,50.988 L34.988,21.188 ZM29.987,26.189 L31.987,24.188 L31.987,50.988 L29.987,51.019 L29.987,26.189 ZM24.987,31.189 L26.987,29.189 L26.987,50.988 L24.987,51.020 L24.987,31.189 ZM19.986,36.190 L21.986,34.189 L21.986,50.989 L19.986,51.020 L19.986,36.190 ZM14.986,41.190 L16.986,39.190 L16.986,50.989 L14.986,50.990 L14.986,41.190 ZM9.985,46.191 L11.985,44.191 L11.985,51.021 L9.985,50.990 L9.985,46.191 ZM4.985,50.628 L6.985,48.628 L6.985,51.021 L4.985,50.990 L4.985,50.628 Z"
            />
            <Path
              intent={props.intent}
              d="M36.997,0.981 L50.008,0.981 L50.008,13.991 L36.997,0.981 Z"
            />
          </Svg>
        : <Svg>
            <Path
              intent={props.intent}
              d="M47.936,47.952 L0.570,0.587 L0.573,3.920 L46.270,49.617 L46.268,49.619 L47.936,47.952 Z"
            />
            <Path
              intent={props.intent}
              fillOpacity={0.259}
              d="M46.177,43.568 L46.179,43.565 L44.989,42.375 L44.989,1.992 L46.989,2.019 L46.989,44.380 L46.177,43.568 ZM39.988,2.022 L41.989,2.022 L41.989,39.375 L39.988,37.375 L39.988,2.022 ZM34.988,2.029 L36.988,2.029 L36.988,34.374 L34.988,32.374 L34.988,2.029 ZM29.987,1.997 L31.987,2.028 L31.987,29.374 L29.987,27.374 L29.987,1.997 ZM24.987,1.996 L26.987,2.028 L26.987,24.373 L24.987,22.373 L24.987,1.996 ZM19.986,1.996 L21.986,2.027 L21.986,19.373 L19.986,17.373 L19.986,1.996 ZM14.986,2.027 L16.986,2.027 L16.986,14.372 L14.986,12.372 L14.986,2.027 ZM9.985,2.026 L11.985,1.995 L11.985,9.372 L9.985,7.372 L9.985,2.026 ZM4.985,2.026 L6.985,1.995 L6.985,7.976 L4.985,5.975 L4.985,2.026 Z"
            />
            <Path
              intent={props.intent}
              d="M36.997,51.988 L50.008,51.988 L50.008,38.977 L36.997,51.988 Z"
            />
          </Svg>}
    </ArrowView>
  );
});

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/Chart/ArrowTiny.js